import AppShell from "components/AppShell";
import PerformanceReview from "components/PerformanceReview";
import PerformanceReview4c from "components/PerformanceReview4c";

export const InteractiveDemo4c = () => {
  return (
    <AppShell headerLabel="Feedback" showSidebar={false} showDemoAppNavbar={false}>
      <PerformanceReview4c />
    </AppShell>
  );
}

export default function InteractiveDemoPerformance() {

  return (
    <AppShell headerLabel="Feedback" showSidebar={false} showDemoAppNavbar={false}>
      <PerformanceReview />
    </AppShell>
  );
}